import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import {
	changeCurrentPath,
	fetchDecodeProcessList,
	resetDecodeProcessListState,
	uploadManualDecodeNew,
	cancelManualDecode,
} from '../../actions';

import {getValueHash} from '../../common/utils/array';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import Tables from '../../common/components/table/common-table';
import MainButtons from '../../common/components/main-buttons';

import Viewer from "./components/viewer";

const columns = [
	{ name: 'UploadDateTime', title:'取込日時' ,width:190},
	{ name: 'UploadFileName', title:'ファイル名' ,width:200},
	{ name: 'ProcessMessage', title:'内容',width:650 },
	{ name: 'NGCount', title: 'QR読込エラー',width:120 },
	{ name: 'ManualInput', title: ' ',width:120,sortingEnabled:false,filteringEnabled: false},
];

const numberColumns = [];


const styles = theme => ({
	cautionText:{
		marginTop:-10
	}
});


class DecodeProcessList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows : [],
			dialogOpen : false,
			dialogOpenUndo:false,
			undoRow : {},
			detailData : [],
			managementId : null
        };


    }
    /** override methods **/
	UNSAFE_componentWillMount(){
    	this.handleClickSumup();
		const {dispatch} = this.props;
		dispatch(resetDecodeProcessListState());
	}
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
	componentWillUnmount(){
		const { dispatch} = this.props;
		dispatch(resetDecodeProcessListState());
	}
	handleClickSumup = event => {
		const {dispatch,auth} = this.props;
		dispatch(fetchDecodeProcessList({
			JigyoushaCD : auth.user.JigyoushaCD,
			UserID : auth.user.UserID,
		}));
	};

	handleClickBack = event => {
		this.props.history.push('/consignee-list-new');
	};

	handleClickManualInput = row =>{
		this.setState({
			detailData : getValueHash(row.Details),
			managementId : row.ManagementID
		})
	};

	handleSaveManualInput = (detail_data) =>{
		const {dispatch,auth} = this.props;

		detail_data.forEach(row=>{
			row["SlipDate"] = moment(row["SlipDate"]).format('YYYY/MM/DD')
		});
		dispatch(uploadManualDecodeNew({
			detail_data,
			ManagementID : this.state.managementId,
			SessionID : auth.SessionID,
			JigyoushaCD : auth.user.JigyoushaCD,
			UserID : auth.user.UserID
		}));

		this.setState({
			detailData : [],
			managementId : null
		});

	};

	handleCancelManualInput = () =>{
		this.setState({
			detailData : [],
			managementId : null
		});

	};

	handleDeleteManualInput = () =>{
		const {dispatch,auth} = this.props;
		dispatch(cancelManualDecode({
			ManagementID : this.state.managementId,
			SessionID : auth.SessionID,
			JigyoushaCD : auth.user.JigyoushaCD,
			UserID : auth.user.UserID
		}));

		this.setState({
			detailData : [],
			managementId : null
		});

	};


	render() {
		const {classes,settings} = this.props;
		const {detailData} = this.state;

		const rows = settings.data;

		const mainButtons = [
			{type:'BACK',func:this.handleClickBack,text:"一覧"},
			{type:'RELOAD',func:this.handleClickSumup,text:"更新"}
		];

		const clickableColumns = [
			{name:'ManualInput',func:this.handleClickManualInput,type:'button',text:'伝票番号登録',visibleKeyColumn:'IsManualInput'},
		];

		const showManualInput = (detailData.length !== 0);

		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>受付状況</h2>
					</section>
					<p className={classes.cautionText}>
						※アップロードしたファイルが数百ページの場合、伝票マッチングに<strong>数時間</strong>かかる場合がございます。ご了承ください。
					</p>
					<section className="with_button">
						<Tables
							dataSource={rows}
							columns={columns}
							numberColumns={numberColumns}
							clickableColumns={clickableColumns}
							defaultSorts={[{columnName:'UploadDateTime',direction:'desc'}]}
							isShowSlectionCount={false}
							hasSelections={false}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				{showManualInput &&
				<Viewer
					dataSource={detailData}
					afterSaveFunc={this.handleSaveManualInput}
					afterCloseFunc={this.handleCancelManualInput}
					afterDeleteFunc={this.handleDeleteManualInput}
				/>
				}
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.decodeProcessListSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(DecodeProcessList);



// WEBPACK FOOTER //
// ./src/routes/decode-process-list/index.js